import { authSlice } from '@wellesley/auth/authSlice'
import { useSelector } from 'react-redux'
import { PlatformSettings } from '@wellesley/openapi'
import { useHasUserPermissions } from '@wellesley/auth/hooks/useHasUserPermissions'

import { useGetApiV1SettingsQuery } from '../../api'
import { adminOnlyPlatformSettingsKeys, platformSettingsKeys } from '../../keys'

const useFetchPlatformSettings = (
  keys?: (keyof PlatformSettings)[],
  skip = false,
) => {
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)

  const hasAccessToAdminSettings = useHasUserPermissions([
    { resource: 'AdminSettings', actions: ['Read'] },
  ])

  const defaultKeys = [
    ...platformSettingsKeys,
    ...(isLogged && hasAccessToAdminSettings
      ? adminOnlyPlatformSettingsKeys
      : []),
  ]

  const platformKeys = keys || defaultKeys

  useGetApiV1SettingsQuery(
    {
      keys: platformKeys,
    },
    { skip },
  )
}

export default useFetchPlatformSettings
